/**
 * [mojdzial1006, paczka MD-KIT → właściciel MD-START, projekt §2.2, §2.9, §3.1] REJESTR — START „DO ZAŁATWIENIA” (`/moj-dzial`).
 *
 * Start ma `id: "start"` (stała KIT `OBSZAR_STARTU`) i pole `zakladka: "pulpit"` (identyfikator serwera — tryby i wejścia
 * imienne dalej mówią „pulpit”), ale ŻADNE źródło Startu nie pyta z `zakladka=pulpit`: każde pyta zakładką swojego miejsca
 * (2.5, 2.9, decyzja D23). Start jest zawsze dostępny (`dostepMiejsca(start) = null`) — także przy wejściu imiennym bez „pulpit”.
 * Pasek: „Szukaj miejsca lub osoby…” (D-9: wynik = miejsca i osoby), „Odśwież”, „Więcej ▾”; bez akcji głównej (pełny przycisk
 * ma pierwszy wiersz listy). `komponent` = zaślepka `pages/mojDzial/miejsca/Start.js` (wypełnia MD-START).
 */
import { FiGrid } from "react-icons/fi";
import { obszarStartu } from "../ksztalt";
import { ETYKIETA_STARTU_MOJEGO_DZIALU, PARAMETR_DZIALU, ZDANIE_MOJEGO_DZIALU, obiektyMiejsca } from "./wspolne";

/** Zdarzenia okna, po których start liczy listę na nowo (2.12 — liczy powłoka, odbicie 400 ms). */
export const ZDARZENIA_STARTU = Object.freeze([
    "hr-notification", "approvals-changed", "hr-request-changed", "calendar-changed",
    "goal-upserted", "goal-removed", "drive-access-changed", "career-changed",
]);

export const miejsceStartu = obszarStartu({
    kluczTrasy: "mojDzialStart",
    zakladka: "pulpit",
    etykieta: ETYKIETA_STARTU_MOJEGO_DZIALU,
    zdanie: ZDANIE_MOJEGO_DZIALU,
    ikona: FiGrid,
    filtry: ["moje", PARAMETR_DZIALU],
    obiekty: obiektyMiejsca(),
    pasek: { szukajka: "Szukaj miejsca lub osoby…" },
    zdarzeniaNaZywo: ZDARZENIA_STARTU,
    sekcje: [],
    slowa: ["pulpit", "do załatwienia", "start", "co czeka", "dziś w zespole", "nieobecni dziś", "kafle"],
    komponent: () => import("../../../pages/mojDzial/miejsca/Start"),
});

export default miejsceStartu;
